import { render } from "./Sidebar.vue?vue&type=template&id=15d573ba&scoped=true"
import script from "./Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=15d573ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d573ba"],['__file',"src/components/modals/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15d573ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15d573ba', __exports__)) {
    api.reload('15d573ba', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=15d573ba&scoped=true", () => {
    api.rerender('15d573ba', render)
  })

}


export default __exports__